module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_robot-7e7fb9715f968a72ae9f3d3bcdf86e23.jpg";